import { getRequest, postRequest } from '../request/request.service';
import { OUTBOUND_API } from './outbound-calls.constants';
import {
  OutboundCall,
  OutboundCallsParams,
  OutboundCallsResponse,
  PlaceTestCallPayload,
  PlaceTestCallResponse,
} from './calls.service.types';

export function getOutboundCalls(params: OutboundCallsParams) {
  return getRequest<OutboundCallsResponse>(OUTBOUND_API, { params });
}

export function getOutboundCall(id: number) {
  return getRequest<OutboundCall>(`${OUTBOUND_API}/${id}`);
}

/** Places a real call through Twilio. Errors carry `{errors, code}`. */
export function placeTestCall(payload: PlaceTestCallPayload) {
  return postRequest<PlaceTestCallResponse>(OUTBOUND_API, { data: payload });
}
